import { useContext, useRef } from "react";
import WrapperMyData from "../../views/my-data/MyData.styles";
import NavBar from "../nav-bar/NavBar";
import { changePassword } from "../../hooks/firebase"; // Import da função
import { NotificationContext } from "../../context/NotificationContext";

const MyChangePassword = () => {
    const inputARef = useRef(null);
    const inputBRef = useRef(null);
    const inputCRef = useRef(null);
    const {addNotification} = useContext(NotificationContext)

    function switchInputMode(ref) {
        let type = ref.current.getAttribute("type");

        if (type === "text") {
            ref.current.setAttribute("type", "password");
        } else {
            ref.current.setAttribute("type", "text");
        }
    }

    async function handleChangePassword() {
        const currentPassword = inputARef.current.value.trim();
        const newPassword = inputBRef.current.value.trim();
        const confirmPassword = inputCRef.current.value.trim();

        if (!currentPassword || !newPassword || !confirmPassword) {
            addNotification("Por favor, preencha todos os campos.", "info")
            return;
        }

        if (newPassword !== confirmPassword) {
            addNotification("A nova senha e a confirmação não coincidem.", "error")
            return;
        }

        try {
            const message = await changePassword(currentPassword, newPassword);
            addNotification(message, "success")
            inputARef.current.value = "";
            inputBRef.current.value = "";
            inputCRef.current.value = "";
        } catch (error) {
            addNotification("Algo deu errado", "error")
        }
    }

    return (
        <WrapperMyData>
            <NavBar />
            <div className="container-change-password">
                <div className="line">
                    <span className="title">Senha Atual:</span>
                    <div className="input-box">
                        <input type="password" ref={inputARef} />
                        <span className="sufix" onClick={() => switchInputMode(inputARef)}>Mostrar</span>
                    </div>
                </div>
                <div className="line">
                    <span className="title">Nova Senha:</span>
                    <div className="input-box">
                        <input type="password" ref={inputBRef} />
                        <span className="sufix" onClick={() => switchInputMode(inputBRef)}>Mostrar</span>
                    </div>
                </div>
                <div className="line">
                    <span className="title">Confirme a Nova Senha:</span>
                    <div className="input-box">
                        <input type="password" ref={inputCRef} />
                        <span className="sufix" onClick={() => switchInputMode(inputCRef)}>Mostrar</span>
                    </div>
                </div>
                <span className="button" onClick={handleChangePassword}>
                    Salvar
                </span>
            </div>
        </WrapperMyData>
    );
};

export default MyChangePassword;
